import React, { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { PageTitle } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ title: "", description: "", due_date: "" });
  const load = () => api.get("/agent/tasks").then((r) => setTasks(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/agent/tasks", f); toast.success("Task added"); setOpen(false); setF({ title: "", description: "", due_date: "" }); load(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  const toggle = async (id) => { await api.patch(`/agent/tasks/${id}`); load(); };

  const openT = tasks.filter((t) => !t.completed);
  const doneT = tasks.filter((t) => t.completed);

  return (
    <div>
      <PageTitle title="My Tasks" subtitle="Follow-ups and onboarding activities">
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="new-task-btn" className="bg-navy hover:bg-navy/90"><Plus className="mr-2 h-4 w-4" /> Add Task</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle className="font-heading">Add task</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-4" data-testid="task-form">
              <Input data-testid="task-title" placeholder="Task title" required value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} />
              <Input data-testid="task-desc" placeholder="Description" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} />
              <Input data-testid="task-due" type="date" value={f.due_date} onChange={(e) => setF({ ...f, due_date: e.target.value })} />
              <Button type="submit" data-testid="task-submit-btn" className="w-full bg-navy hover:bg-navy/90">Add task</Button>
            </form>
          </DialogContent>
        </Dialog>
      </PageTitle>

      <div className="space-y-2">
        {openT.map((t) => (
          <Card key={t.id} className="flex items-center gap-3 p-4" data-testid={`task-${t.id}`}>
            <Checkbox data-testid={`task-check-${t.id}`} checked={false} onCheckedChange={() => toggle(t.id)} />
            <div className="flex-1">
              <p className="font-medium text-navy">{t.title}</p>
              {t.description && <p className="text-sm text-slate-500">{t.description}</p>}
            </div>
            {t.due_date && <span className="text-xs text-slate-400">{String(t.due_date).slice(0, 10)}</span>}
          </Card>
        ))}
        {openT.length === 0 && <Card className="p-10 text-center text-slate-400">No open tasks. Great work!</Card>}
      </div>

      {doneT.length > 0 && (
        <>
          <h3 className="mb-2 mt-8 font-heading text-sm font-semibold uppercase tracking-wide text-slate-400">Completed</h3>
          <div className="space-y-2">
            {doneT.map((t) => (
              <Card key={t.id} className="flex items-center gap-3 p-4 opacity-60">
                <Checkbox checked onCheckedChange={() => toggle(t.id)} />
                <p className="flex-1 font-medium text-slate-500 line-through">{t.title}</p>
              </Card>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
